<script>

import { Overlay } from '../../'

export default {
    name: 'ForceIndex',
    mixins: [Overlay],
    methods: {
        meta_info() {
            return {
                author: 'StdSquad', version: '1.0.0',
                desc: 'Force Index - Measures the strength of buyers and sellers',
                preset: {
                    name: 'Force Index $length',
                    side: 'offchart',
                    settings: {
                        lineWidth: 1.5,
                        color: '#e91e63'
                    }
                }
            }
        },
        use_for() { return ['ForceIndex'] },
        calc() {
            return {
                props: {
                    length: { def: 13, text: 'Length' }
                },
                conf: { renderer: 'Spline' },
                update: `
                    let force = ts((close[0] - close[1]) * vol[0])
                    return ema(force, length)[0]
                `
            }
        }
    }
}
</script>
